import { Link } from 'react-router-dom';

function DuneaLogo({ size = 20 }: { size?: number }) {
  return (
    <div className="flex items-center gap-2">
      <img src="/dunea-mark.svg" width={size} height={size} alt="" style={{ display: 'block' }} />
      <span className="ui-brand" style={{ fontSize: size * 0.9, letterSpacing: '-0.01em' }}>
        Dunea
      </span>
    </div>
  );
}

export default function NotFoundPage() {
  return (
    <div className="ui-root min-h-[100dvh] bg-page flex flex-col">
      {/* Sticky header */}
      <div className="flex items-center gap-2.5 px-[18px] py-[14px] border-b border-hairline">
        <DuneaLogo size={20} />
        <div className="flex-1" />
      </div>

      {/* Hero */}
      <div className="flex-1 relative flex items-center justify-center px-5 py-10 overflow-hidden sm:px-10">
        {/* dot grid */}
        <div
          aria-hidden
          className="absolute inset-0 opacity-45 pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '64px 64px',
          }}
        />
        {/* radial accent glow */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'radial-gradient(ellipse 50% 70% at 50% 60%, rgba(217,242,106,0.08) 0%, transparent 60%)',
          }}
        />

        <div className="relative text-center max-w-[440px]">
          <div
            className="ui-serif relative text-primary"
            style={{ fontSize: 140, lineHeight: 1, letterSpacing: '-0.04em' }}
          >
            4<span className="text-accent">0</span>4
            <span
              aria-hidden
              className="absolute inset-0 -z-1"
              style={{
                background: 'radial-gradient(ellipse 40% 60% at 50% 60%, rgba(217,242,106,0.25) 0%, transparent 70%)',
                filter: 'blur(20px)',
              }}
            />
          </div>
          <span className="ui-caption text-accent">This page wandered off.</span>
          <h2 className="ui-serif text-primary" style={{ fontSize: 28, margin: '10px 0 8px' }}>
            Nothing here, yet.
          </h2>
          <p
            className="mx-auto text-secondary"
            style={{ maxWidth: 340, margin: '0 auto 20px', fontSize: 13.5, lineHeight: 1.6 }}
          >
            The address might be wrong, or this project was deleted by its owner. Try one of these instead.
          </p>
          <div className="flex gap-2 justify-center">
            <button type="button" className="ui-btn-secondary" onClick={() => window.history.back()}>
              <span className="i-ph:arrow-left text-[13px]" />
              Back
            </button>
            <Link to="/" className="ui-btn-accent">
              Go to dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
